import React, { useState } from 'react';
import { X, ArrowRight } from 'lucide-react';

const WorkGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const facebookPageLink = 'https://www.facebook.com/profile.php?id=61581426567365';

  const workImages = [
    { id: 1, src: '/assets/images/work/work-1.jpeg', alt: 'Car Exterior Detailing' },
    { id: 2, src: '/assets/images/work/work-2.jpeg', alt: 'Interior Deep Clean' },
    { id: 3, src: '/assets/images/work/work-3.jpeg', alt: 'Wheel Cleaning' },
    { id: 4, src: '/assets/images/work/work-4.jpeg', alt: 'Engine Bay Clean' },
    { id: 5, src: '/assets/images/work/work-5.jpeg', alt: 'Full Valet Service' },
    { id: 6, src: '/assets/images/work/work-6.jpeg', alt: 'Paint Protection' },
    { id: 7, src: '/assets/images/work/work-7.jpeg', alt: 'Steam Cleaning' },
    { id: 8, src: '/assets/images/work/work-8.jpeg', alt: 'Before and After' },
  ];

  const handleSeeMore = () => {
    window.open(facebookPageLink, '_blank');
  };

  return (
    <section className="section section-white">
      <div className="container">
        <div className="section-header">
          <div className="badge">Our Work</div>
          <h2>See The Difference We Make</h2>
          <p>Professional results that speak for themselves. Browse our gallery of completed jobs.</p>
        </div>

        <div className="gallery-grid">
          {workImages.map((image) => (
            <div 
              key={image.id}
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <img 
                src={image.src} 
                alt={image.alt}
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?w=800';
                }}
              />
            </div>
          ))}
        </div>

        <div className="gallery-cta">
          <button 
            onClick={handleSeeMore}
            className="see-more-btn"
          >
            See More
            <ArrowRight size={20} />
          </button>
        </div>

        {selectedImage && (
          <div 
            className="gallery-lightbox"
            onClick={() => setSelectedImage(null)}
          >
            <button 
              onClick={() => setSelectedImage(null)}
              className="gallery-lightbox-close"
            >
              <X size={24} />
            </button>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>

    </section>
  );
};

export default WorkGallery;